// extracted by mini-css-extract-plugin
module.exports = {"waveDivider":"WaveDivider_waveDivider__pIbSE","top":"WaveDivider_top__zNmzx","bottom":"WaveDivider_bottom__saYKN","slide":"WaveDivider_slide__gqXIz"};